// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hl","advertCardFooter__row":"c-a_hm","advertCardFooter__name":"c-a_hn","advertCardFooter__price":"c-a_ho","advertCardFooter__age":"c-a_hp"};